__turbopack_context__.v({
  "actionsSection": "header-section-module-scss-module__5lMGaG__actionsSection",
  "container": "header-section-module-scss-module__5lMGaG__container",
});
